export default __webpack_public_path__ + "static/media/LU-logo-LV.a5431c2a.png";